import { Markup } from 'interweave';
import * as style from '../styles';
import { Button } from '@enaep-ng/benchmark';
import { ButtonProps } from '../types';

// check for markup text to have custom style/css applied at view level for more flexibility.
const PrimaryButton = (props: ButtonProps) => {
  return (
    <Button
      variant="bare"
      onClick={props.action}
      style={{...style.primaryButtonStyle, ...props.style}}
    >
      <Markup attributes={{ key: props.key || '1' }} content={props.label} />
    </Button>
  );
};

const SecondaryButton = (props: ButtonProps) => {
  return (
    <Button
      variant="bare"
      onClick={props.action}
      style={style.secondaryButtonStyle}
    >
      <Markup attributes={{ key: props.key || '1' }} content={props.label} />
    </Button>
  );
};
export { SecondaryButton, PrimaryButton };
